<template>
  <!--
    M1-B (balão 1) — a situação do prazo é o primeiro nível de navegação. Os números são os
    MESMOS `byView` que as colunas abertas do Kanban da Onda 2 vão usar (§5.2).
    `border-solid` é obrigatório: o reset global `button { border-style: none }` apaga
    qualquer borda de botão sem ele (e `ring-*` não desenha aqui) — DEV-QA do PR #2839.
  -->
  <div
    class="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5"
    role="group"
    aria-label="Visões rápidas das solicitações"
    data-testid="activity-requests-quick-views"
  >
    <button
      v-for="view in ACTIVITY_REQUEST_QUICK_VIEWS"
      :key="view.key"
      type="button"
      class="flex flex-col items-start gap-0.5 rounded-lg border-2 border-t-4 border-solid px-3 py-2 text-left transition"
      :class="[
        view.key === active
          ? 'border-primary30 bg-primary5'
          : 'border-lightGray30 bg-white hover:bg-gray-50',
        QUEUE_TONE_BORDER_CLASS[view.tone]
      ]"
      :aria-pressed="view.key === active"
      :data-testid="`activity-requests-quick-view-${view.key}`"
      @click="emit('select', view.key)"
    >
      <span class="text-xs font-bold text-neutral50">{{ view.label }}</span>
      <span
        class="text-2xl font-bold text-textPrimary"
        :data-testid="`activity-requests-quick-view-${view.key}-count`"
      >
        {{ countOf(view.key) }}
      </span>
      <span class="text-[11px] text-neutral50">{{ view.hint }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { QUEUE_TONE_BORDER_CLASS } from '@/components/designSystem/QueueViews/types'
import type { ModuleViewCounters } from '@/components/designSystem/QueueViews/types'
import { ACTIVITY_REQUEST_QUICK_VIEWS } from '@/constants/activity-requests.constants'
import type { ActivityRequestQuickViewKey } from '@/types/activity-requests.types'

const props = defineProps<{
  counters: ModuleViewCounters | null
  active: ActivityRequestQuickViewKey
  loading?: boolean
}>()

const emit = defineEmits<{ select: [key: ActivityRequestQuickViewKey] }>()

/** Sem contador (carregando ou falhou) é "—": um 0 inventado diria "tudo em dia". */
const countOf = (key: ActivityRequestQuickViewKey): string => {
  if (props.loading) return '…'
  const value = props.counters?.byView?.[key]
  return typeof value === 'number' ? value.toLocaleString('pt-BR') : '—'
}
</script>
